// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2INoh","comment":"styles_comment__cRY3O"};